<div *ngIf="aichat" class="container">
  <div class="sidebar">
    <button class="new-chat-btn" (click)="newChat()">
      <i class="ti ti-plus"></i>
      <span>New Chat</span>
    </button>

    <div class="chat-history">
      <ng-container *ngIf="isLoadingChats">
        <div class="skeleton-history-item" *ngFor="let s of skeletonRows">
          <div class="skeleton-bar skeleton-icon"></div>
          <div class="skeleton-bar skeleton-title"></div>
        </div>
      </ng-container>
      <ng-container *ngIf="!isLoadingChats">
        <div
          *ngFor="let chat of chats"
          class="chat-history-item"
          [class.active]="chat.id === activeChatId"
          (click)="selectChat(chat.id)"
        >
          <i class="ti ti-message-circle"></i>
          <span class="chat-title">{{ chat.title }}</span>
        </div>
      </ng-container>
    </div>
  </div>

  <div class="chat-panel">
    <div class="header">
      <label>AI Chat</label>
      <div class="close-btn" (click)="closeChatBox()">
        <i class="ti ti-chevron-down"></i>
      </div>
    </div>
    <div class="chat-messages" #chatMessages>
      <ng-container *ngIf="isLoadingActiveChat">
        <ng-container *ngFor="let s of skeletonRows">
          <div class="d-block">
            <div class="skeleton-bar skeleton-bubble skeleton-right"></div>
          </div>
          <div class="d-block">
            <div class="skeleton-bar skeleton-bubble skeleton-left"></div>
          </div>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="!isLoadingActiveChat">
        <div *ngFor="let message of messages" class="d-block">
          <div
            [ngClass]="{
              'user-message': message.sender === 'user',
              'ai-message': message.sender === 'ai',
            }"
          >
            {{ message.text }}
          </div>

          <div class="sources-block" *ngIf="message.sources?.length">
            <div class="sources-heading">
              <i class="ti ti-books"></i>
              <span>Sources</span>
            </div>
            <div class="sources-list">
              <div
                class="source-chip"
                *ngFor="let source of message.sources"
                [title]="'Click to view ' + source.label"
                [class.downloading]="downloadingSource === (source.url || source.source_path)"
                (click)="downloadSource(source)"
              >
                <i
                  class="ti"
                  [ngClass]="
                    downloadingSource === (source.url || source.source_path)
                      ? 'ti-loader-2 spin'
                      : 'ti-file-text'
                  "
                ></i>
                <span>{{ source.label }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="d-block" *ngIf="isTyping">
          <div class="ai-message typing-message">
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
            <span class="typing-dot"></span>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="chat-input">
      <input
        [(ngModel)]="newMessage"
        [disabled]="isTyping"
        [placeholder]="isTyping ? 'Waiting for a response...' : 'Type a message...'"
        (keydown)="sendMessageOnEnter($event)"
      />
      <div class="button-bg">
        <button (click)="sendMessage()" [disabled]="isTyping || !newMessage.trim()">
          <i class="ti ti-send-2"></i>
        </button>
      </div>
    </div>
    <div class="disclaimer">AI can make mistakes, so double-check it</div>
  </div>
</div>
